(function() {
  const shopDetailWrapper = document.getElementById('shop_detail');

  let $slider = $('#shop_detail .shop_detail___slider');

  // slider起動
  $slider.slick({
    infinite: true,
    arrows: true,
    autoplay: false,
    dots: true,
    dotsClass: 'thumbnails',
    customPaging: function(slick,index) {
      // スライダーのインデックス番号に対応した画像のsrcを取得
      var targetImage = slick.$slides.eq(index).find('img').attr('src');
      // slick-dotsに上記で取得した画像を設定
      return '<img src=" ' + targetImage + ' "/>';
    }
  });
})();